module.exports = __webpack_public_path__ + "510105aa9f2ab1682a0224ed9a974c5a.png";